// Splash Screen - Responsive Multi-Platform
import { useEffect } from 'react';
import { useApp } from '../hooks/useApp';
import { SCREENS } from '../config/constants';
import { storage } from '../services/storage';
import { Container, Text } from '../components/ui';

function SplashScreen() {
    const { setCurrentScreen } = useApp();

    useEffect(() => {
        const timer = setTimeout(() => {
            const hasOnboarded = storage.hasOnboarded();
            setCurrentScreen(hasOnboarded ? SCREENS.HOME : SCREENS.ONBOARDING);
        }, 2000);
        return () => clearTimeout(timer);
    }, [setCurrentScreen]);

    return (
        <Container className="min-h-screen flex flex-col items-center justify-center bg-theme-bg" safe>
            {/* Logo */}
            <div className="relative w-28 h-28 mb-8">
                <div className="absolute inset-0 bg-primary/20 rounded-3xl animate-pulse" />
                <div className="absolute inset-2 bg-gradient-to-br from-primary to-primary-light rounded-2xl flex items-center justify-center">
                    <span className="text-4xl">👅</span>
                </div>
            </div>

            {/* Title */}
            <Text variant="h2" className="mb-2">Thiệt Chuẩn AI</Text>
            <Text variant="caption" className="mb-8">Y Học Cổ Truyền × AI</Text>

            {/* Loading dots */}
            <div className="flex gap-2">
                {[0, 1, 2].map((i) => (
                    <div
                        key={i}
                        className="w-2 h-2 rounded-full bg-primary animate-pulse"
                        style={{ animationDelay: `${i * 0.2}s` }}
                    />
                ))}
            </div>
        </Container>
    );
}

export default SplashScreen;
